const HTTPBackend = require('i18next-http-backend');
const LanguageDetector = require('i18next-browser-languagedetector');

const { CDN_URL } = process.env;

const LOCALE_KEY = 'uniLocaleCode';

const locales = {
  DE: 'de_DE',
  EN: 'en_GB',
  ES: 'es_ES',
  FR: 'fr_FR',
  IT: 'it_IT',
  NL: 'nl_NL',
  PL: 'pl_PL',
  PT: 'pt_PT',
  ZH: 'zh_CN'
};
const localeRegex = RegExp('^/[a-zA-Z]{2}($|/)');

const getLanguageFromPath = path => (localeRegex.test(path) ? path.slice(1, 3) : '');

const languageToLocale = (language = 'en') => locales[language.toUpperCase()];

const localeToLanguage = (locale = locales.EN) => {
  const language = Object.keys(locales).find(key => locales[key] === locale) || 'en';

  return language.toLowerCase();
};

const LangDetector = LanguageDetector.default || LanguageDetector;

const languageDetector = new LangDetector();
const {
  detectors: {
    cookie: { lookup, cacheUserLanguage }
  }
} = languageDetector;

languageDetector.addDetector({
  name: 'url',

  lookup() {
    return getLanguageFromPath(location.pathname);
  }
});

languageDetector.addDetector({
  name: 'customCookie',

  lookup(options) {
    return localeToLanguage(lookup(options));
  },

  cacheUserLanguage(lng, options) {
    return cacheUserLanguage(languageToLocale(lng), options);
  }
});

module.exports = {
  i18n: {
    detection: {
      order: ['url', 'customCookie'],
      lookupCookie: LOCALE_KEY,
      cookieDomain: process.env.COOKIE_DOMAIN,
      caches: ['customCookie']
    },
    fallbackLng: 'en',
    debug: process.env.DEBUG,
    defaultLocale: 'en',
    locales: Object.keys(locales).map(locale => locale.toLowerCase()),
    ns: ['header', 'footer', 'translations'],
    defaultNS: ['translations'],
    backend: {
      loadPath: ([lng], namespace) => {
        const locale = languageToLocale(lng);

        return `${CDN_URL}/locales/${locale}/${namespace}.json`;
      },
      addPath: ([lng], namespace) => {
        const locale = languageToLocale(lng);

        return `${CDN_URL}/locales/${locale}/${namespace}.json`;
      },
      allowMultiLoading: true
    },
    interpolation: {
      escapeValue: false
    }
  },
  serializeConfig: false,
  use: [HTTPBackend.default || HTTPBackend, languageDetector]
};
